// extracted by css-extract-rspack-plugin
export default {"cls1":"session_trail-cls1_J3C","cls2":"session_trail-cls2_u_p session_trail-cls1_J3C"};